import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-contact-source',
  templateUrl: './dialog-contact-source.component.html',
  styleUrls: ['./dialog-contact-source.component.scss'],
})
export class DialogContactSourceComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data) {}
}
